export default __webpack_public_path__ + "static/media/icon-relogio.324e8639.svg";